import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import { OrderStatus } from '~/services/order';
dayjs.extend(utc);
dayjs.extend(relativeTime);

export const formatOrderStatusFlows = (status: OrderStatus) => {
    switch (status) {
        case OrderStatus.CANCELLED: {
            return [
                {
                    icon: 'bag-tick',
                    name: 'Order Placed',
                    active: true
                },
                {
                    icon: 'close',
                    name: 'Cancel',
                    danger: true
                }
            ];
        }
        default: {
            const data: {
                icon: string;
                name: string;
                active?: boolean;
                danger?: boolean;
            }[] = [
                {
                    icon: 'bag-tick',
                    name: 'Processing',
                    active: true
                },
                {
                    icon: 'truck-fast',
                    name: 'Delivering',
                    active: [OrderStatus.IN_TRANSIT].includes(status)
                },
                {
                    icon: 'box',
                    name: 'Received',
                    active: [OrderStatus.DELIVERED].includes(status)
                }
            ];

            return data;
        }
    }
};

export const timeNow = (date: any) => {
    if (!date) return '';
    try {
        return dayjs.utc(date).fromNow();
    } catch (e) {
        console.log(e);
    }
};

export function capitalizeFirstLetter(str: string): string {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
